<template>
  <a-modal
    :visible="visible"
    width="450px"
    :body-style="bodyStyle"
    centered
    :footer="null"
    @cancel="handleCloseModal"
  >
    <div class="container__inactive">
      <img class="image__delete" :src="deleteImage" alt="delete" />
      <p class="text__alert">¿Estás seguro de eliminar el perfil “{{ profile?.name }}”?</p>
      <p class="text">
        Actualmente cuentas con {{ profile?.total_users }} usuarios en este perfil. Recuerda que
        debes seleccionar un perfil alternativo al cual se reasignarán todos los usuarios que se
        encuentran actualmente asignados a este perfil.
      </p>

      <a-form
        class="form text-left"
        layout="vertical"
        :model="formState"
        ref="formRef"
        :rules="rules"
      >
        <a-row :gutter="24">
          <a-col span="24">
            <a-form-item label="Nuevo perfil asignado" name="idTransfer">
              <a-select
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                v-model:value="formState.idTransfer"
                placeholder="Seleccionar nuevo perfil"
                @change="disabled = false"
              >
                <a-select-option v-for="profile in profiles" :key="profile.id">
                  {{ profile.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="button__disabled">
      <a-button
        style="width: 100%"
        :disabled="disabled"
        :loading="loading"
        class="footer__delete"
        type="primary"
        @click="fetchDelete"
      >
        Eliminar perfil
      </a-button>
    </div>
  </a-modal>
</template>

<script>
import { defineComponent, ref, computed, reactive } from "vue";
import { useStore } from "vuex";
import { fetchActiveUsers } from "@/app/settings/services";
import { updateProfileSocket } from "@/app/shared/services";

import deleteImage from "@/app/users/assets/profiles/delete.png?url";

export default defineComponent({
  name: "DeleteProfileModal",
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const confirmText = ref("");
    const disabled = ref(true);
    const store = useStore();
    const loading = ref(false);
    const user = computed(() => store.getters["getDataUser"]);
    const profile = computed(() => store.getters["getProfile"]);
    const profiles = computed(() =>
      store.getters["getProfileList"].filter((p) => p.id !== profile.value.id)
    );
    const formRef = ref();
    const formState = reactive({
      idTransfer: null,
    });
    const rules = {
      idTransfer: [{ required: true, message: "Campo requerido" }],
    };
    const bodyStyle = {};
    return {
      confirmText,
      bodyStyle,
      user,
      profile,
      formRef,
      formState,
      rules,
      profiles,
      disabled,
      loading,
      deleteImage,
    };
  },
  methods: {
    async fetchDelete() {
      try {
        this.loading = true;
        const users = await fetchActiveUsers();
        const usersProfile = users.results.filter(
          (user) => user.profile == this.profile.id && user.status == 1
        );

        usersProfile.forEach(async (user) => {
          await updateProfileSocket({
            customer_id: this.user.customer.id,
            user_id: user.id,
            title: "Un administrador ha eliminado tu perfil",
            description:
              "Se te ha asignado un nuevo perfil. Tus permisos podrían cambiar según su configuración.",
          });
        });

        await this.$store.dispatch("deleteProfile", {
          id: this.profile.id,
          data: { profile_to_assign: this.formState.idTransfer },
        });

        this.handleCloseModal();
        this.loading = false;
        this.$message.success(
          "Se ha eliminado el perfil “" + this.profile.name + "” correctamente"
        );
      } catch (error) {
        console.log(error);
        this.$message.error("Error al eliminar el perfil");
      }
    },
    handleCloseModal() {
      this.formState.idTransfer = null;
      this.$emit("onCancel", this.profile.name);
    },
  },
});
</script>

<style lang="sass" scoped>
.image__delete
  margin-bottom: 10px

.text__alert
  font-size: 16px
  font-weight: 600

.text
  margin-bottom: 20px

.button__disabled
  margin-top: 10px

.strong
  font-weight: 600

.footer__delete
  margin-bottom: 20px

.container__inactive
  text-align: center
.text-left
  text-align: left
</style>
